import React from 'react';

const NetworkArchitectureDiagram: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg transition-all duration-300">
      <h2 className="mb-6 text-2xl font-bold text-center text-blue-800">网络架构图</h2>
      <p className="mb-4 text-gray-600 text-center max-w-4xl mx-auto">
        网络架构设计实现了多层次安全保障与高效数据传输
      </p>
      
      <div className="relative w-full h-[450px] bg-gradient-to-b from-gray-50 to-gray-100 rounded-lg p-6">
        <div className="space-y-4">
          {/* 外部网络安全层 */}
          <div className="bg-blue-100 rounded-lg p-4 border-2 border-blue-300 shadow-md">
            <h3 className="text-center font-medium text-blue-800 mb-3">外部网络安全层</h3>
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-white rounded p-3 text-sm text-center border border-blue-200">
                <div className="font-medium">Web防火墙</div>
                <div className="text-xs text-gray-500 mt-1">WAF防护</div>
              </div>
              <div className="bg-white rounded p-3 text-sm text-center border border-blue-200">
                <div className="font-medium">负载均衡器</div>
                <div className="text-xs text-gray-500 mt-1">F5/Nginx</div>
              </div>
              <div className="bg-white rounded p-3 text-sm text-center border border-blue-200">
                <div className="font-medium">DDoS防护</div>
                <div className="text-xs text-gray-500 mt-1">流量清洗</div>
              </div>
            </div>
          </div>

          {/* 应用服务层 */}
          <div className="flex justify-between gap-6">
            {/* Fusion应用区域 */}
            <div className="flex-1 bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-4 border-2 border-red-300 shadow-md">
              <h3 className="text-center font-medium text-red-800 mb-3">Fusion应用区域</h3>
              <div className="space-y-3">
                <div className="bg-white rounded p-3 text-sm border border-red-200">
                  <div className="font-medium mb-2">应用服务集群</div>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div className="bg-red-50 p-1 rounded">交易服务</div>
                    <div className="bg-red-50 p-1 rounded">风控服务</div>
                  </div>
                </div>
              </div>
            </div>

            {/* X-Ray应用区域 */}
            <div className="flex-1 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border-2 border-blue-300 shadow-md">
              <h3 className="text-center font-medium text-blue-800 mb-3">X-Ray应用区域</h3>
              <div className="space-y-3">
                <div className="bg-white rounded p-3 text-sm border border-blue-200">
                  <div className="font-medium mb-2">应用服务集群</div>
                  <div className="grid grid-cols-2 gap-2 text-xs">
                    <div className="bg-blue-50 p-1 rounded">分析服务</div>
                    <div className="bg-blue-50 p-1 rounded">预警服务</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 数据安全层 */}
          <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-4 border-2 border-green-300 shadow-md">
            <h3 className="text-center font-medium text-green-800 mb-3">数据安全层</h3>
            <div className="grid grid-cols-4 gap-4">
              <div className="bg-white rounded p-3 text-sm text-center border border-green-200">
                <div className="font-medium">数据库集群</div>
                <div className="text-xs text-gray-500 mt-1">主从架构</div>
              </div>
              <div className="bg-white rounded p-3 text-sm text-center border border-green-200">
                <div className="font-medium">缓存集群</div>
                <div className="text-xs text-gray-500 mt-1">Redis集群</div>
              </div>
              <div className="bg-white rounded p-3 text-sm text-center border border-green-200">
                <div className="font-medium">消息队列</div>
                <div className="text-xs text-gray-500 mt-1">Kafka集群</div>
              </div>
              <div className="bg-white rounded p-3 text-sm text-center border border-green-200">
                <div className="font-medium">对象存储</div>
                <div className="text-xs text-gray-500 mt-1">MinIO集群</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-blue-50 rounded-lg shadow-sm">
        <h3 className="font-semibold text-blue-800 mb-2">网络架构说明</h3>
        <p className="text-sm text-gray-700">
          网络架构采用多层次安全设计，通过外部网络安全层、应用服务层和数据安全层的划分，形成完整的安全防护体系。
          外部网络安全层配备WAF、DDoS防护和负载均衡器，为系统提供全方位安全防护。应用服务层采用区域隔离，
          Fusion和X-Ray系统分别部署在独立网络区域，通过安全网关进行通信。数据安全层采用高可用集群部署，
          确保数据服务的可靠性和安全性。整体架构符合等保三级要求，实现了系统安全性与业务连续性的平衡。
        </p>
      </div>
    </div>
  );
};

export default NetworkArchitectureDiagram; 